import { Col, Row } from "@/common/css";
import { H2, LightText, LightText2 } from "@/common/ui/Text";
import React from "react";
import ReviewStatus from "./ReviewStatus";
import FileNameWithIcon from "./FileNameWithIcon";
import { Button } from "@/components/ui/button";
import { getFileExtension } from "@/utils/helper/fileUploadValidation";
import moment from "moment";
import { FORMATE, PERMISSIONS } from "@/utils/constant/global.constant";
import { loginSelector } from "@/store/features/loginSlice";
import { useSelector } from "react-redux";
import { isHasPermission } from "@/utils/helper/permissions";

interface DocumentViewCardProps {
  documentInfo: any;
  openModal: (modalKey: string, props?: any) => void;
}

const DocumentViewCard: React.FC<DocumentViewCardProps> = ({ documentInfo, openModal }) => {
  const { status, doc, lookup, added_dt, approved_ts, reason } = documentInfo;
  const { currentUser } = useSelector(loginSelector);

  const handleViewDocument = () => {
    const fileExtension = getFileExtension(doc?.path);
    if (fileExtension !== "pdf") {
      return openModal("filePreview", { file: { name: doc?.name, url: doc?.path } });
    }
    const link = document.createElement("a");
    link.href = doc?.path;
    link.target = "_blank";
    link.click();
  };

  const handleUpdateDocument = () => {
    openModal("updateDocument", { documentInfo });
  };

  return (
    <Col className="w-full md:min-w-[500px] md:max-w-[500px] rounded-llg gap-y-4 pb-4 !pt-0 border border-stroke-light">
      <Row className="justify-between py-19 border-b-[1px] border-stroke-light px-4 gap-y-4">
        <H2 text={lookup?.name} />
        <ReviewStatus status={status} />
      </Row>
      <Row className=" w-full justify-between">
        <Col className="px-4 !py-0">
          <LightText text="Submitted on" className=" !font-bold" />
          <LightText2 text={moment(added_dt).format(FORMATE.DATE)} />
        </Col>
        {approved_ts && status !== "PENDING" && (
          <Col className="px-4 !py-0">
            <LightText text={status === "DECLINED" ? "Declined on" : "Approved on"} className=" !font-bold" />
            <LightText2 text={moment(approved_ts).format(FORMATE.DATE)} />{" "}
          </Col>
        )}
      </Row>

      <Row className="px-4 !py-0">
        <FileNameWithIcon name={doc?.name} />
      </Row>
      <Row className="justify-between px-4 !py-0">
        <Button variant="link" className="text-13 text-text-primary !p-1 " onClick={handleViewDocument}>
          View document
        </Button>
        <Button
          variant="outline"
          className="text-13 text-text-primary !rounded-50 !leading-normal"
          disabled={!isHasPermission(currentUser?.perms, PERMISSIONS.SETTING["Edit Documents"])}
          onClick={handleUpdateDocument}
        >
          Update document
        </Button>
      </Row>
      {status === "DECLINED" && (
        <Col className=" px-4 py-3 gap-y-1.5 bg-text-error/10 rounded-xl m-4">
          <H2 text="Reason" />
          <LightText2 className="text-ellipsis" text={reason} />
        </Col>
      )}
    </Col>
  );
};

export default DocumentViewCard;
